import { useState } from "react";
import { Link } from "react-router-dom";
import { http, formatApiError } from "../lib/api";
import { ArrowLeft, Mail } from "lucide-react";
import { BrandBlock } from "../components/BrandBlock";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await http.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e2) { setErr(formatApiError(e2)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-white p-6">
      <div className="w-full max-w-sm">
        <div className="mb-10">
          <BrandBlock size="md" />
        </div>

        {sent ? (
          <>
            <div className="mb-6 flex items-center gap-3 rounded-md border border-emerald-200 bg-emerald-50 text-emerald-800 px-4 py-3">
              <Mail className="h-5 w-5"/>
              <div className="text-sm"><b>Demande prise en compte.</b><br/>Si un compte existe pour <b>{email}</b>, un email de réinitialisation vient de vous être envoyé (valable 1h).</div>
            </div>
            <Link to="/login" className="inline-flex items-center gap-2 text-sm text-sky-700 hover:underline"><ArrowLeft className="h-4 w-4"/>Retour à la connexion</Link>
          </>
        ) : (
          <>
            <h1 className="font-display text-4xl font-extrabold tracking-tight mb-2">Mot de passe oublié</h1>
            <p className="text-sm text-slate-600 mb-8">Indiquez votre email, nous vous enverrons un lien de réinitialisation. <span className="block mt-1 text-xs text-slate-500" data-testid="forgot-admin-only">Réservé aux administrateurs : les autres utilisateurs demandent un nouveau mot de passe à leur administrateur.</span></p>
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <label className="text-[10px] font-bold uppercase tracking-widest text-slate-500">Email</label>
                <input data-testid="forgot-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)}
                  className="mt-1 w-full border border-slate-300 rounded-md px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-sky-500 focus:border-sky-500"/>
              </div>
              {err && <div className="text-sm text-rose-600 bg-rose-50 border border-rose-200 rounded-md px-3 py-2">{err}</div>}
              <button data-testid="forgot-submit" disabled={loading} className="w-full disabled:opacity-70 text-white font-semibold rounded-md py-2.5 text-sm transition-colors hover:opacity-90" style={{ backgroundColor: "var(--brand-primary)" }}>{loading?"Envoi…":"Envoyer le lien"}</button>
            </form>
            <div className="mt-8">
              <Link to="/login" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-slate-900"><ArrowLeft className="h-4 w-4"/>Retour</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
